import { render, staticRenderFns } from "./HorizontalWarning.vue?vue&type=template&id=a6603a5a"
import script from "./HorizontalWarning.vue?vue&type=script&lang=js"
export * from "./HorizontalWarning.vue?vue&type=script&lang=js"
import style0 from "./HorizontalWarning.vue?vue&type=style&index=0&id=a6603a5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports